import { formatDisplayDateTime } from '@/utils/date';
import { GPS_COORDINATE_DECIMALS } from '../constants/instituteSubmission.constants';

interface PhotoCaptureStampProps {
  latitude: number | null;
  longitude: number | null;
  capturedAt: string | null;
}

export function PhotoCaptureStamp({ latitude, longitude, capturedAt }: PhotoCaptureStampProps) {
  if (latitude === null || longitude === null) return null;

  return (
    <>
      {latitude.toFixed(GPS_COORDINATE_DECIMALS)}° N &nbsp;{' '}
      {longitude.toFixed(GPS_COORDINATE_DECIMALS)}° E
      {capturedAt && (
        <>
          <br />
          {formatDisplayDateTime(capturedAt)}
        </>
      )}
    </>
  );
}
